import { connect } from 'react-redux';
import { IStoreState } from 'src/entity/StateEntity';
import PrimaryLayout from '../components/layouts/PrimaryLayout';
import { Dispatch } from 'redux';
import { getDoctorToApprove, getDoctorNeedConfigure, getOrderPending, setPreOrderSendStatus } from 'src/redux/actions/webSocketCreator';

const mapStateToProps = ({ authState: { menuItem }, userState: { isAgent, userInfo } }: IStoreState) => ({
  menuItem,
  isAgent,
  userInfo
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    getDoctorToApprove: () => dispatch(getDoctorToApprove()),
    getDoctorNeedConfigure: () => dispatch(getDoctorNeedConfigure()),
    getOrderPending: (hasNewOrder: boolean) => dispatch(getOrderPending(hasNewOrder)),
    setPreOrderSendStatus: (orderUUID: string) => dispatch(setPreOrderSendStatus(orderUUID)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrimaryLayout);



// WEBPACK FOOTER //
// ./src/containers/PrimaryLayout.ts